import React from 'react';
import PropTypes from 'prop-types';

const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '14px',
    background: '#fff',
};

const thTdStyle = {
    border: '1px solid #ccc',
    padding: '2px',
    textAlign: 'center',
};

const CurrentDasa = ({ dasaRecords }) => {

    // Extract dasaRecordsCurrent from dasaRecords
    const dasaRecordsCurrent = React.useMemo(() => {
        if (!dasaRecords || !Array.isArray(dasaRecords)) return [];

        // Helper to parse date string (Sinhala months supported)
        function parseDate(str) {
            const match = str && str.match(/^(\d{4})-([^-]+)-(\d{2})/);
            if (!match) return null;
            const months = {
                "ජන": "01", "පෙබ": "02", "මාර්": "03", "අප්‍රේල්": "04", "මැයි": "05", "ජූනි": "06",
                "ජූලි": "07", "අගෝ": "08", "සැප්": "09", "ඔක්": "10", "නොවැ": "11", "දෙසැ": "12"
            };
            const year = match[1];
            const month = months[match[2]] || "01";
            const day = match[3];
            return `${year}-${month}-${day}`;
        }

        // Helper to flatten all dasa records at level 3
        function flattenL3(records) {
            let result = [];
            if (!records || !Array.isArray(records)) return result;
            records.forEach(l1 => {
                if (l1.dasaDataNextLevel) {
                    l1.dasaDataNextLevel.forEach(l2 => {
                        if (l2.dasaDataNextLevel) {
                            l2.dasaDataNextLevel.forEach(l3 => {
                                result.push({
                                    ...l3,
                                    dasaL1: l1.dasaL1,
                                    dasaL2: l2.dasaL2
                                });
                            });
                        }
                    });
                }
            });
            return result;
        }

        // Get all L3 records
        const allL3 = flattenL3(dasaRecords);

        // Get years
        const now = new Date();
        const thisYear = now.getFullYear();
        const years = [thisYear - 1, thisYear, thisYear + 1];

        // Filter by from or to year in last, this, or next year
        return allL3.filter(r => {
            const fromDate = parseDate(r.from);
            const toDate = parseDate(r.to);
            if (!fromDate || !toDate) return false;
            const fromYear = Number(fromDate.slice(0, 4));
            const toYear = Number(toDate.slice(0, 4));
            return years.includes(fromYear) || years.includes(toYear);
        });
    }, [dasaRecords]);
    // dasaRecordsCurrent


    return (
        <div style={{ overflowX: 'auto', margin: '0 0 24px 0' }}>
            <div style={{ textAlign: 'left', marginTop: '32px', fontWeight: 'bold', fontSize: '0.8em' }}>
                වර්තමාන දසා තත්ත්වය
            </div>
            <table style={tableStyle}>
                <thead>
                    <tr>
                        <th style={thTdStyle}>දසාව</th>
                        <th style={thTdStyle}>අතුරු දසා</th>
                        <th style={thTdStyle}>විදසා</th>
                        <th style={thTdStyle}>සිට</th>
                        <th style={thTdStyle}>දක්වා</th>
                        <th style={thTdStyle}>කාල පරාසය</th>
                    </tr>
                </thead>
                <tbody>
                    {dasaRecordsCurrent.map((row, idx) => (
                        <tr key={idx}>
                            <td style={thTdStyle}>{row.dasaL1}</td>
                            <td style={thTdStyle}>{row.dasaL2}</td>
                            <td style={thTdStyle}>{row.dasaL3}</td>
                            <td style={thTdStyle}>{row.from}</td>
                            <td style={thTdStyle}>{row.to}</td>
                            <td style={thTdStyle}>{row.duration}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

CurrentDasa.propTypes = {
    dasaRecords: PropTypes.array.isRequired,
};

export default CurrentDasa;
